import { withRouter } from 'react-router';

const NotFoundPage = ({ router }) => {
  router.push('/');
  return null;
};

export default withRouter(NotFoundPage);



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js